import React from 'react';
import { observer } from "mobx-react";

import { Upload, message, Button, Icon } from 'antd';

import { ProjectStoreContext } from './AppContexts';


@observer
class UploadData extends React.Component {
	static contextType = ProjectStoreContext;

	uploadStatusChange({ file, fileList, event }) {
		console.log(file);
		console.log(event);
		if (file.status == 'error'){
		}
		else if (file.status == 'done'){
		}
	}

	render() {
		let authHeaders = this.context.auth.getAuthHeaders();
		return (
			<Upload name='file' action={this.context.uploadAction} headers={this.authHeaders} onChange={this.uploadStatusChange}>
				<Button>
					<Icon type="upload" /> Click to Upload
				</Button>
			</Upload>
		);
	}
}

export { UploadData };
